export default __webpack_public_path__ + "static/media/eSupport-not-selected_skyblue.03e597ea.svg";